/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const BANNER_IMPRESSION_EVENT = 'banner_impression';
export const BANNER_INTERACTION_EVENT = 'banner_interaction';
export const OFFER_INBOX_BANNER_TYPE = 'Offer Inbox';
export const OFFER_INBOX_CLICK_GROUP = 'Click';
export const OFFER_INBOX_IMPRESSION_GROUP = 'Impression';

export const OFFER_INBOX_EMAIL_OPT_IN = {
    bannerType: OFFER_INBOX_BANNER_TYPE,
    bannerGroup: 'Enter Email',
    bannerItemName: 'Email Opt In',
};

export const OFFER_INBOX_SMS_OPT_IN = {
    bannerType: 'Offer Inbox SMS Input',
    bannerGroup: 'Submit SMS',
    bannerItemName: 'Submit SMS',
};
export const OFFER_INBOX_HEADER_ITEM = 'Offer Inbox Deals';
export const OFFER_INBOX_SEE_MORE_ITEM = 'See more offers';
export const OFFER_INBOX_EXIT_INTENT_ITEM = 'Exit Intent';
export const OFFER_INBOX_ENTRANCE_ITEM = 'Entrance';
export const CUSTOMER_OPT_IN_TEST_BANNER_TYPE = 'Customer Opt In Test';

export const getAbsoluteClickUrl = (url = '') => {
    if (!url) {
        return '';
    }

    if (url.includes('http:') || url.includes('https:')) {
        return url;
    }

    const origin = typeof window !== 'undefined' && window.location?.origin ? window.location.origin : '';
    return `${origin}${url}`;
};

export const getOfferPromoCode = (offer) => offer?.value?.value?.offerGatewayRecipe?.offerBannerCode || '';

export const getOfferName = (offer) => offer?.value?.name
    || offer?.name
    || offer?.title
    || offer?.content?.title
    || '';

// CMS tracking fields map to banner keys: category -> banner_type, action -> banner_group, label -> banner_item_name
export const getCmsBannerFields = (tracking) => ({
    bannerType: tracking?.tracking_event_category,
    bannerGroup: tracking?.tracking_event_action,
    bannerItemName: tracking?.tracking_event_label,
});

export const buildOfferInboxBannerEvent = ({
    eventName = BANNER_INTERACTION_EVENT,
    bannerType,
    bannerGroup,
    bannerItemName,
    clickId,
    clickText,
    clickUrl,
}) => ({
    eventName,
    eventCategory: eventName,
    eventAction: eventName,
    eventLabel: bannerItemName || eventName,
    ga_event_name: eventName,
    interaction_type: eventName,
    banner_type: bannerType || OFFER_INBOX_BANNER_TYPE,
    banner_group: bannerGroup || OFFER_INBOX_CLICK_GROUP,
    banner_item_name: bannerItemName || '',
    click_id: clickId,
    click_text: clickText || '',
    click_url: getAbsoluteClickUrl(clickUrl),
});
